import React from "react";
import Icon from "../Icon";

export default function StepWizard({ step }) {
  const steps = [
    { label: "Test Type" },
    { label: "Biomarkers" },
    { label: "Review" }
  ];
  return (
    <div className="d-flex justify-content-center align-items-center mb-4" style={{ background: "#f7f9fc", borderRadius: 12, padding: "18px 0" }}>
      {steps.map((s, idx) => {
        const isDone = step > idx + 1;
        const isActive = step === idx + 1;
        return (
          <React.Fragment key={s.label}>
            <div className="d-flex align-items-center" style={{ minWidth: 90 }}>
              <div
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  background: isDone ? "#22c55e" : isActive ? "#2563eb" : "#fff",
                  border: `2px solid ${isDone ? "#22c55e" : isActive ? "#2563eb" : "#dbeafe"}`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: isDone ? "#fff" : isActive ? "#fff" : "#2563eb",
                  fontWeight: 600,
                  fontSize: 16,
                  marginBottom: 2,
                  transition: "all 0.2s"
                }}
              >
                {isDone ? (
                  <Icon icon="check" width={22} height={22} style={{ color: "#fff" }} />
                ) : (
                  idx + 1
                )}
              </div>
              <div
                style={{
                  fontWeight: isDone || isActive ? 600 : 500,
                  color: isDone ? "#22c55e" : isActive ? "#2563eb" : "#64748b",
                  fontSize: 15
                }}
                className="ps-2"
              >
                {s.label}
              </div>
            </div>
            {idx < steps.length - 1 && (
              <div style={{
                flex: "0 0 80px",
                height: 2,
                background: isDone ? "#22c55e" : "#e5e7eb",
                margin: "0 8px"
              }} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
